import Nav from '../../components/breadcrumb';
import PageHeader, { Title, ActionBar, ActionButton as Btn } from '../../components/pageheader';
import { Form, Table, Card, Row, Col } from 'react-bootstrap';
import { SortButton } from '../../components/btns';
import { useState, useEffect } from 'react';
import PagePagination, { usePagination } from '../../components/pagination';
import { Link } from 'react-router-dom';
import { useScreenType } from '../../components/custom-hooks';
import moment from 'moment';
import { sortFunction, UCWords } from "../../components/resources";
import { getUsers } from '../../resources/api/users';
import { ErrorLoading, PageLoading } from '../../components/loading';


/**
 * 
 * @typedef {{
 * id: string,
 * contact_id: string,
 * display_name: string
 * other_names: string
 * last_name: string
 * email: string
 * telephone: string
 * job_title: string
 * permission_level: number
 * roles: string[]
 * rm_accounts: {id: string, title: string}[]
 * last_logged_in: string
 * last_changed_password: string
 * status: string
 * }} UserObject 
 */

/**
 * View table items on screens larger than md
 * @param {Object} props
 * @param {{currentField: string, currentOrder: "asc" | "desc"}} props.srt
 * @param {(field: string) => void} props.handleSort
 * @param {UserObject[]} props.items
 * @param {number} props.currentPage
 * @param {number} props.noPageItems
*/
const ViewDesktop = ({ srt, handleSort, items, currentPage, noPageItems }) => {

    const El = ({ field, children, ...props }) =>
        <th
            {...props}
            style={{ whiteSpace: "nowrap" }}
        >
            {children} <SortButton field={field} {...srt} handleSort={handleSort} />
        </th>;

    return (
        <Table responsive hover style={{ minWidth: '700px' }}>
            {/* <colgroup>
                <col span="1" style={{ width: "3%" }} />
                <col span="1" style={{ width: "25%" }} />
                <col span="1" style={{ width: "12%" }} />
                <col span="1" style={{ width: "12%" }} />
                <col span="1" style={{ width: "12%" }} />
                <col span="1" style={{ width: "16%" }} />
                <col span="1" style={{ width: "16%" }} />
            </colgroup> */}
            <thead>
                <tr>
                    <th>#</th>
                    <El field="display_name">Name</El>
                    <El field="telephone">Telephone</El>
                    <El field="email">Email</El>
                    <El field="job_title">Job Title</El>
                    <El field="permission_level">Permissions</El>
                    <El field="last_logged_in">Last Logged</El>
                    <El field="status">Acc Status</El>
                </tr>

            </thead>
            <tbody>
                {items.map((e, i) => (
                    <tr key={i}>
                        <td>{(currentPage - 1) * noPageItems + i + 1}</td>
                        <td>
                            <Link to={`/app/users/${e.id}`}>{e.display_name}</Link>
                        </td>
                        <td>{e.telephone}</td>
                        <td>{e.email}</td>
                        <td>{e.job_title}</td>
                        <td>{e.permission_level}</td>
                        <td>{moment(e.last_logged_in).format("DD MMM YYYY")}</td>
                        <td>{UCWords(e.status.replace(/-/g, " "))}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    )
}

/**
 * view items on screens smaller than md
 * @param {Object} props
 * @param {{currentField: string, currentOrder: "asc" | "desc"}} props.srt
 * @param {(field: string) => void} props.handleSort
 * @param {UserObject[]} props.items
 */
const ViewMobile = ({ srt, handleSort, items }) => {

    const El = ({ field, children }) => (
        <span className="small text-nowrap m-1 py-1 px-2 bg-teal text-white rounded-pill">
            {children} <SortButton field={field} {...srt} handleSort={handleSort} />
        </span>
    )
    return (
        <div className="my-3">
            <div className="mb-3" style={{ whiteSpace: 'nowrap', overflowX: 'auto', maxWidth: '100%' }}>
                <El field="display_name">Name</El>
                <El field="email">Email</El>
                <El field="job_title">Job Title</El>
                <El field="last_logged_in">Last Logged In</El>
                <El field="status">Status</El>
            </div>
            {items.map((e, i) => (
                <Card className="my-2 shadow-sm" key={i}>
                    <Card.Body className="px-3">
                        <div className="d-flex justify-content-between mb-2">
                            <span className="text-secondary font-weight-normal text-uppercase">{e.status}</span>
                            <span className="text-muted font-weight-normal">{moment(e.last_logged_in).format("DD MMM YYYY")}</span>
                        </div>

                        <div className="lead mb-2">
                            <Link to={`/app/users/${e.id}`} className="stretched-link">{e.display_name}</Link>
                        </div>
                        <Row>
                            <Col xs={4} className="small">
                                Email
                            </Col>
                            <Col xs={8}>
                                {e.email}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={4} className="small">
                                Telephone
                            </Col>
                            <Col xs={8}>
                                {e.telephone}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={4} className="small">
                                Job Title
                            </Col>
                            <Col xs={8}>
                                {e.job_title}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={4} className="small">
                                Permission Level
                            </Col>
                            <Col xs={8}>
                                {e.permission_level}
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            ))}
        </div>
    )
}

/**
 * module that handles view of accounts
 * match path /app/accounts
 */
const ViewUsers = () => {

    const navItems = [{ title: 'Users' }];

    const [srt, setSrt] = useState({
        currentField: 'title',
        currentOrder: 'asc'
    });

    const [noPageItems, setNoPageItems] = useState(10);
    const [displayItems, setDisplayItems] = useState([]);
    const [items, setItems] = useState([]);
    const [orginalItems, setOriginalItems] = useState([]);
    const [search, setSearch] = useState({ val: '', field: 'display_name' });

    const screenType = useScreenType();
    const [PAGE, NOPAGES, setPage] = usePagination(items.length, noPageItems);

    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);

    /**
     * whenever the page changes, scroll back to the top of the list.
     */
    useEffect(() => {
        if (PAGE === 1) return;
        window.scrollTo({ top: 100, behavior: "smooth" });
    }, [PAGE])

    /**
     * whenever the value and field change ie. a search, 
     * filter the items and view on the page.
     */
    useEffect(() => {
        const v = search.val, f = search.field;
        if (v.length < 2 || f === "") return setItems(orginalItems);
        setItems([...orginalItems.filter(i => i[f].toLowerCase().indexOf(v.toLowerCase()) !== -1)]);
    }, [search.val, search.field, orginalItems]);


    /**
     * get the items
     */
    useEffect(() => {

        getUsers()
            .then(({ users }) => {
                setOriginalItems(users);
                setItems(users);
            })
            .catch(err => setError(err))
            .finally(() => setLoaded(true))
    }, [])


    /**
     * Update display items whenever 
     * (1) => the page changes 
     * (2) => the number of items a page changes 
     * (3) => items change in any way
     */
    useEffect(() => {

        const ditems = [],
            start = (PAGE * noPageItems) - noPageItems,
            end = (PAGE * noPageItems) > items.length ? items.length : PAGE * noPageItems;

        for (let index = start; index < end; index++) {
            ditems.push(items[index]);
        }

        setDisplayItems(ditems);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [PAGE, noPageItems, JSON.stringify(items)])

    /**
     * Is triggered when 
     * (1) => user has changed the sort field
     * (2) => user has changed sort order
     * (3) => user has changed length of items (i.e., there are new items in the page)
     */
    useEffect(() => {

        const comp = (a, b) => sortFunction(a, b, srt.currentField, srt.currentOrder);

        setItems(items => [...items].sort(comp));

    }, [srt.currentField, srt.currentOrder, items.length])

    /**
     * handle when someone clicks the sort button
     * @param {string} field 
     */
    const handleSort = field => {
        if (field === srt.currentField) {
            setSrt(d => ({ ...d, currentOrder: d.currentOrder === 'asc' ? 'desc' : 'asc' }));
        } else {
            setSrt(d => ({ currentField: field, currentOrder: 'asc' }));
        }
    }

    if (!loaded) return <PageLoading />

    if (error) return <ErrorLoading>{error}</ErrorLoading>


    return (
        <>
            <Nav items={navItems} />

            <PageHeader maxWidth="1000">
                <Title>Users</Title>
                <ActionBar>
                    <Btn href="/app/users/new">
                        <i className="fas fa-plus-circle me-1" />New User
                    </Btn>
                </ActionBar>
            </PageHeader>

            <div className="max-1000">
                <Row xs={{ cols: "auto" }} className="align-items-center justify-content-md-end mb-3 flex-nowrap g-0">
                    <Col>

                        <Form.Control placeholder="Search For" size="sm"
                            value={search.val}
                            onChange={e => setSearch({ ...search, val: e.currentTarget.value })}
                        />
                    </Col>
                    <Col>
                        <span className="mx-1">in</span>
                    </Col>
                    <Col>
                        <Form.Select as="select" size="sm"
                            value={search.field}
                            onChange={e => setSearch({ ...search, field: e.currentTarget.value })}
                        >
                            <option value="display_name">Name</option>
                            <option value="email">Email</option>
                            <option value="telephone">Telephone</option>
                            <option value="job_title">Job Title</option>
                        </Form.Select>
                    </Col>


                </Row>

                {screenType === 'desktop' ?
                    <ViewDesktop srt={srt} handleSort={handleSort} items={displayItems} noPageItems={noPageItems} currentPage={PAGE} /> :
                    <ViewMobile srt={srt} handleSort={handleSort} items={displayItems} />
                }

                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center">
                    <Row xs={{ cols: "auto" }} className="align-items-center g-0 flex-nowrap mb-2">

                        <Col className="me-2 text-nowrap">No Items:</Col>
                        <Col>
                            <Form.Select
                                value={noPageItems}
                                onChange={e => setNoPageItems(parseInt(e.currentTarget.value))}
                                size="sm"
                                style={{ maxWidth: '100px' }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </Form.Select>
                        </Col>

                        <Col className="ms-2 text-nowrap">{items.length} of {orginalItems.length}</Col>
                    </Row>
                    <PagePagination
                        page={PAGE}
                        no_pages={NOPAGES}
                        setPage={setPage}
                    />
                </div>
            </div>
        </>
    )
}


export default ViewUsers;